export default __webpack_public_path__ + "static/media/epochMode.0ae87189.png";